import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/HomeView.vue'),
    },
    {
      path: '/mode',
      name: 'mode',
      component: () => import('@/views/ModeSelectView.vue'),
    },
    {
      path: '/record',
      name: 'record',
      component: () => import('@/views/RecordView.vue'),
    },
    {
      path: '/preference',
      name: 'preference',
      component: () => import('@/views/PreferenceView.vue'),
    },
    {
      path: '/result',
      name: 'result',
      component: () => import('@/views/ResultView.vue'),
    },
    {
      path: '/songs',
      name: 'songs',
      component: () => import('@/views/SongsView.vue'),
    },
  ],
})

export default router
